module.exports = __webpack_public_path__ + "img/polygon.58cab152.svg";